import { getOrCreateBox } from 'api/box'
import { Company, SnackbarSeverity } from 'constant'
import { OrderItem } from 'models'
import { createContext, ReactNode, useContext, useState } from 'react'
import { SnackContext } from './SnackContextProvider'
import { LoadingContext } from './LoadingContextProvider'

interface BoxOrderContextType {
  racks: any[]
  setRacks: React.Dispatch<React.SetStateAction<any[]>>
  selectedRack: string | null
  setSelectedRack: React.Dispatch<React.SetStateAction<string | null>>
  selectedClass: string | null
  setSelectedClass: React.Dispatch<React.SetStateAction<string | null>>
  boxCode: string
  setBoxCode: React.Dispatch<React.SetStateAction<string>>
  orderItems: OrderItem[]
  setOrderItems: React.Dispatch<React.SetStateAction<OrderItem[]>>
  boxItems: any[]
  setBoxItems: React.Dispatch<React.SetStateAction<any[]>>
  handleGetOrCreateBox: Function
}

export const BoxOrderContext = createContext<BoxOrderContextType>({
  racks: [],
  setRacks: () => {},
  selectedRack: null,
  setSelectedRack: () => {},
  selectedClass: null,
  setSelectedClass: () => {},
  boxCode: '',
  setBoxCode: () => {},
  orderItems: [],
  setOrderItems: () => {},
  boxItems: [],
  setBoxItems: () => {},
  handleGetOrCreateBox: () => {}
})

interface Props {
  children: ReactNode
}

const BoxOrderContextProvider = ({ children }: Props) => {
  const [racks, setRacks] = useState<any[]>([])
  const [selectedRack, setSelectedRack] = useState<string | null>(null)
  const [selectedClass, setSelectedClass] = useState<string | null>(null)
  const [boxCode, setBoxCode] = useState('')
  const [orderItems, setOrderItems] = useState<OrderItem[]>([])
  const [boxItems, setBoxItems] = useState<any[]>([])

  const { handleOpenSnackbar } = useContext(SnackContext)
  const { setLoading } = useContext(LoadingContext)

  const handleGetOrCreateBox = async (
    inputBoxCode: string,
    setError: React.Dispatch<React.SetStateAction<Boolean>>,
    company: Company,
    locationId: number
  ) => {
    if (!inputBoxCode.trim()) {
      setError(true)
      return
    }
    setLoading(true)
    try {
      const result = await getOrCreateBox(
        `${company}`,
        locationId,
        inputBoxCode
      )
      if (result?.data.success === true) {
        setBoxCode(inputBoxCode)
      } else {
        handleOpenSnackbar(SnackbarSeverity.Error, 'Box not found')
      }
    } catch (error) {
      handleOpenSnackbar(
        SnackbarSeverity.Error,
        'Server error, please try again later'
      )
    }
    setLoading(false)
  }

  return (
    <BoxOrderContext.Provider
      value={{
        racks,
        setRacks,
        selectedRack,
        setSelectedRack,
        selectedClass,
        setSelectedClass,
        boxCode,
        setBoxCode,
        orderItems,
        setOrderItems,
        boxItems,
        setBoxItems,
        handleGetOrCreateBox
      }}
    >
      {children}
    </BoxOrderContext.Provider>
  )
}

export default BoxOrderContextProvider
